import { BadgeCheck, Award, SearchCheck } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { CARRIERS } from "@/constants/config";
import { useLang } from "@/constants/i18n";

const ICONS = [BadgeCheck, Award, SearchCheck];

export const Credentials = () => {
    const { t } = useLang();
    return (
        <section
            id="credenciales"
            data-testid="credentials-section"
            className="bg-ivory py-24 md:py-32"
        >
            <div className="mx-auto max-w-7xl px-5 md:px-10">
                <div className="grid grid-cols-1 gap-16 lg:grid-cols-12">
                    <div className="lg:col-span-5">
                        <SectionHeading
                            number="03"
                            eyebrow={t.credentials.eyebrow}
                            title={t.credentials.title}
                        />
                        <Reveal delay={0.2}>
                            <p className="max-w-md text-base leading-relaxed text-ink/70 md:text-lg">
                                {t.credentials.intro}
                            </p>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-7">
                        <div className="space-y-0">
                            {t.credentials.items.map((cred, i) => {
                                const Icon = ICONS[i % ICONS.length];
                                return (
                                    <Reveal key={cred.title} delay={0.1 + i * 0.1}>
                                        <div
                                            data-testid={`credential-item-${i}`}
                                            className="flex items-start gap-6 border-t border-gold/25 py-8 transition-colors duration-300 hover:bg-tan/10"
                                        >
                                            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-t-full border border-gold/50 bg-burgundy/5">
                                                <Icon className="h-5 w-5 text-burgundy" />
                                            </span>
                                            <div>
                                                <h3 className="font-serif text-xl text-ink md:text-2xl">
                                                    {cred.title}
                                                </h3>
                                                <p className="mt-1 text-sm leading-relaxed text-ink/60">
                                                    {cred.detail}
                                                </p>
                                            </div>
                                        </div>
                                    </Reveal>
                                );
                            })}
                        </div>
                        <Reveal delay={0.4}>
                            <p className="mt-8 text-xs leading-relaxed text-ink/45">
                                {t.credentials.fineprint}
                            </p>
                        </Reveal>
                    </div>
                </div>

                <Reveal delay={0.15}>
                    <div
                        data-testid="carriers-band"
                        className="mt-20 border-t border-gold/25 pt-12 md:mt-28"
                    >
                        <p className="text-center text-xs uppercase tracking-[0.35em] text-ink/50">
                            {t.credentials.carriersTitle}
                        </p>
                        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-14 gap-y-8">
                            {CARRIERS.map((carrier) => (
                                <img
                                    key={carrier.slug}
                                    src={carrier.src}
                                    alt={`Logo de ${carrier.name}`}
                                    data-testid={`carrier-logo-${carrier.slug}`}
                                    className={`w-auto object-contain opacity-70 grayscale transition-[opacity,filter] duration-500 hover:opacity-100 hover:grayscale-0 ${
                                        carrier.tall ? "h-14 md:h-16" : "h-9 md:h-11"
                                    }`}
                                />
                            ))}
                        </div>
                        <p className="mt-8 text-center text-xs text-ink/35">
                            {t.credentials.carriersFine}
                        </p>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};

export default Credentials;
